import React from 'react'
import Form from '../../../common/formComponents/Form'
import FormElement from '../../../common/formComponents/FormElement'
import { Legend } from '../../../common/formComponents/additionalComponents'

// 'New Patient Creation'
// 'Número de Utente'
// 'Nome'
// 'Data de Nascimento'

// Não existe ícone para este
// , {value: 'other', displayValue: translate('genderOther')}

const PatientCreationForm = ({handleSubmit, translate}) => {
  return <Form handleSubmit={handleSubmit}>
    <Legend content={translate('title')} />
    <FormElement type={'number'} label={translate('patientId')} name={'id'} />
    <FormElement type={'text'} label={translate('patientName')} name={'name'} />
    {/* <FormElement type={'file'} label={'Fotografia'} name={'photo'} /> */}
    <FormElement type={'date'} label={translate('birthDate')} name={'birthDate'} />
    <FormElement type={'select'} label={'Sexo'} name={'gender'} options={[{value: 'female', displayValue: translate('genderFemale')}, {value: 'male', displayValue: translate('genderMale')}]} />
    <button className='uk-button uk-button-primary uk-align-right uk-margin-small'>{translate('submitButton')}</button>
  </Form>
}

export default PatientCreationForm
